import { render } from "./TemperatureList.vue?vue&type=template&id=0cfe7634&ts=true"
import script from "./TemperatureList.vue?vue&type=script&lang=ts"
export * from "./TemperatureList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__